import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { readSessionBasicsSafe } from './../../components/Providers/StudentSocketProvider'

const TAWK_PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID;
const TAWK_WIDGET_ID = process.env.REACT_APP_TAWK_WIDGET_ID;
const LOGOUT_EVENT = 'app:logout';


const InstructorChatProvider = ({ children }) => {
  const location = useLocation();
  const isTawkReady = useRef(false);
  const pollRef = useRef(null); // Ref para nuestro temporizador de gracia

  useEffect(() => {
    const handleChatVisibility = () => {
      // ---------------------------------------------------------
      // 1. AQUÍ DEBES LEER TU SESIÓN REAL
      // Ejemplo de cómo deberías adaptarlo:
      const s = readSessionBasicsSafe();
      const isInstructor = s.hasSession && s.role === 2;
      // ---------------------------------------------------------

      //const isInstructor = true; // SIMULACIÓN PARA PRUEBAS: Recuerda cambiar esto por tu validación real

      if (isInstructor) {
        // Si es Instructor y el script aún no existe, lo inyectamos
        if (!document.getElementById('tawk-script')) {
          window.Tawk_API = window.Tawk_API || {};
          window.Tawk_LoadStart = new Date();

          const s1 = document.createElement('script');
          s1.id = 'tawk-script';
          s1.async = true;
          s1.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');

          const s0 = document.getElementsByTagName('script')[0];
          s0.parentNode.insertBefore(s1, s0);

          // Cuando termine de cargar, le decimos que se muestre
          window.Tawk_API.onLoad = function () {
            isTawkReady.current = true;
            if (window.Tawk_API.showWidget) {
              window.Tawk_API.showWidget();
            }
          };
        } else if (isTawkReady.current && window.Tawk_API?.showWidget) {
          // Si ya existía, lo volvemos a mostrar
          window.Tawk_API.showWidget();
        }
      } else {
        // Si NO es Instructor (es Ztudiante o cerró sesión)
        if (isTawkReady.current && window.Tawk_API?.hideWidget) {
          window.Tawk_API.hideWidget();
          // Eliminamos el endChat() que estaba causando que la ventana se abriera sola
        }
      }
    };

    // 1) Intento inmediato al cambiar de ruta
    handleChatVisibility();

    // 2) Evento de logout en el mismo tab
    const onAppLogout = () => {
      if (isTawkReady.current && window.Tawk_API?.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
    window.addEventListener(LOGOUT_EVENT, onAppLogout);

    // 3) Bucle de gracia (6s) por si la sesión de Instructor tarda en guardarse
    // tras pasar la pantalla de "Selección de Centro y Perfil"
    pollRef.current = setInterval(handleChatVisibility, 1000);
    const stopPollTimer = setTimeout(() => {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }, 6000);

    return () => {
      window.removeEventListener(LOGOUT_EVENT, onAppLogout);
      clearTimeout(stopPollTimer);
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };
  }, [location?.pathname]);

  return children;
};

export { InstructorChatProvider };









// import { useEffect, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
// import { readSessionBasicsSafe } from './../../components/Providers/StudentSocketProvider'

// const TAWK_PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID;
// const TAWK_WIDGET_ID = process.env.REACT_APP_TAWK_WIDGET_ID;
// const LOGOUT_EVENT = 'app:logout'; // Usamos el mismo evento que ya tienes

// // Puedes importar aquí tu función readSessionBasicsSafe que ya usas en StudentSocketProvider
// // import { readSessionBasicsSafe } from '../../ruta/a/tu/SessionUtil';

// const InstructorChatProvider = ({ children }) => {
//   const location = useLocation();
//   const isTawkReady = useRef(false);

//   useEffect(() => {
//     const handleChatVisibility = () => {
//       // 1. Aquí lees tu sesión real usando tu lógica actual.
//       // Para el ejemplo asumo que tienes una forma de saber el perfil:
//       const s = readSessionBasicsSafe();
//       const isInstructor = s.hasSession && s.role === 2;

//       // SIMULACIÓN: Cambia esta variable por tu validación real de sesión
//       //const isInstructor = true; // true si es instructor, false si no hay sesión o es Ztudiante

//       if (isInstructor) {
//         // Si ES instructor y el script NO existe en el DOM, lo creamos
//         if (!document.getElementById('tawk-script')) {
//           window.Tawk_API = window.Tawk_API || {};
//           window.Tawk_LoadStart = new Date();

//           const s1 = document.createElement('script');
//           s1.id = 'tawk-script';
//           s1.async = true;
//           s1.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;
//           s1.charset = 'UTF-8';
//           s1.setAttribute('crossorigin', '*');

//           const s0 = document.getElementsByTagName('script')[0];
//           s0.parentNode.insertBefore(s1, s0);

//           // IMPORTANTE: Le decimos a Tawk qué hacer cuando termine de cargar
//           window.Tawk_API.onLoad = function () {
//             isTawkReady.current = true;
//             window.Tawk_API.showWidget();
//           };
//         } else if (isTawkReady.current && window.Tawk_API) {
//           // Si el script ya existía y está cargado, nos aseguramos de que esté visible
//           window.Tawk_API.showWidget();
//         }
//       } else {
//         // Si NO es instructor (ej. cerró sesión o cambió a Ztudiante)
//         if (isTawkReady.current && window.Tawk_API) {
//           window.Tawk_API.hideWidget();
//           // Opcional: Finalizar el chat si había uno activo para limpiar el estado
//           if (typeof window.Tawk_API.endChat === 'function') {
//             window.Tawk_API.endChat();
//           }
//         }
//       }
//     };

//     // Ejecutar validación al cambiar de ruta
//     handleChatVisibility();

//     // Escuchar el logout (igual que en tu StudentSocket)
//     const onAppLogout = () => {
//       if (isTawkReady.current && window.Tawk_API) {
//         window.Tawk_API.hideWidget();
//       }
//     };
//     window.addEventListener(LOGOUT_EVENT, onAppLogout);

//     return () => {
//       window.removeEventListener(LOGOUT_EVENT, onAppLogout);
//     };
//   }, [location?.pathname]);

//   return children;
// };

// export { InstructorChatProvider };









// import React, { createContext, useContext, useEffect, useState, useCallback } from 'react'
// import { useLocation } from 'react-router-dom'
// import { LogErrors } from '../../utilities/LogErrors'

// // TODO: Reemplaza estos valores por los que te da Tawk.to
// const TAWK_PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID
// const TAWK_WIDGET_ID   = process.env.REACT_APP_TAWK_WIDGET_ID

// // -----------------------------------------------------
// // 1) Hook: carga el script de Tawk SOLO una vez
// // -----------------------------------------------------
// export const useTawkLoader = () => {
//   useEffect(() => {
//     // Si ya existe el script, no hacemos nada
//     if (window.Tawk_API || document.getElementById('tawk-script')) return

//     try {
//       window.Tawk_API = window.Tawk_API || {}
//       window.Tawk_LoadStart = new Date()

//       const s1 = document.createElement('script')
//       s1.id = 'tawk-script'
//       s1.async = true
//       s1.src = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`
//       s1.charset = 'UTF-8'
//       s1.setAttribute('crossorigin', '*')

//       const s0 = document.getElementsByTagName('script')[0]
//       s0.parentNode.insertBefore(s1, s0)
//     } catch (error) {
//       console.log('Error cargando Tawk:', error)
//     }
//   }, [])
// }

// // -----------------------------------------------------
// // 2) Contexto para forzar visibilidad desde componentes
// // -----------------------------------------------------
// const TawkContext = createContext({
//   forceVisible: false,
//   setForceVisible: () => {}
// })

// export const TawkProvider = ({ children }) => {
//   const [forceVisible, setForceVisible] = useState(false)

//   const value = {
//     forceVisible,
//     setForceVisible
//   }

//   return (
//     <TawkContext.Provider value={value}>
//       {children}
//     </TawkContext.Provider>
//   )
// }

// // Hook para usar en componentes (dashboard, etc.)
// export const useTawk = () => useContext(TawkContext)

// // -----------------------------------------------------
// // 3) Manager: decide mostrar/ocultar según ruta + contexto
// // -----------------------------------------------------
// export const TawkManager = () => {
//   const location = useLocation()
//   const { forceVisible } = useTawk()
//   const path = location.pathname

//   // Cargar script solo una vez
//   useTawkLoader()

//   // Rutas donde SIEMPRE quieres que se muestre el chat
//   // (puedes editar esta lista según tus necesidades)
//   const staticRoutesWithChat = [
//     '/instructor/ztudents',
//     '/instructor/groups',
//     '/instructor/groups/group',
//     '/instructor/groups/create',
//     '/instructor/progress',
//     '/instructor/agenda',
//     '/instructor/agenda/create',
//     '/instructor/results',
//     '/instructor/syllabus',
//     '/instructor/ztudentView',
//     '/instructor/settings',
//     '/instructor/changeGroup',
//   ]

//   const shouldShowByRoute = staticRoutesWithChat.includes(path)

//   const applyVisibility = useCallback(() => {
//     // Si Tawk aún no está listo, no hacemos nada
//     if (!window.Tawk_API) return

//     const shouldShow = shouldShowByRoute || forceVisible

//     try {
//       if (shouldShow) {
//         window.Tawk_API.showWidget()
//       } else {
//         window.Tawk_API.hideWidget()
//       }
//     } catch (error) {
//       console.log('Error al manejar Tawk:', error)
//     }
//   }, [shouldShowByRoute, forceVisible])

//   useEffect(() => {
//     applyVisibility()
//   }, [applyVisibility, path])

//   // No pinta nada en pantalla
//   return null
// }










// // Chat.js
// import { useEffect } from 'react'

// const TAWK_SCRIPT_ID = 'tawk-to-script'

// export function useTawkLoader() {
//   useEffect(() => {
//     // Si ya cargamos el script antes, no lo volvemos a insertar
//     if (document.getElementById(TAWK_SCRIPT_ID)) return

//     // Inicializamos las variables que Tawk espera
//     window.Tawk_API = window.Tawk_API || {}
//     window.Tawk_LoadStart = new Date()

//     // Opcional: al cargar por primera vez, ocultamos el widget
//     window.Tawk_API.onLoad = function () {
//       try {
//         window.Tawk_API.hideWidget()
//       } catch (e) {
//         console.log('Error ocultando Tawk al cargar:', e)
//       }
//     }

//     const script = document.createElement('script')
//     script.async = true
//     script.src = 'https://embed.tawk.to/692f6f8b7d43ed1981ed0f62/1jbgknegb' // tu URL real de Tawk
//     script.charset = 'UTF-8'
//     script.setAttribute('crossorigin', '*')
//     script.id = TAWK_SCRIPT_ID

//     document.body.appendChild(script)
//   }, [])
// }










// // import { useEffect } from 'react'

// // const TAWK_SCRIPT_ID = 'tawk-to-script'

// // export function useTawkLoader() {
// //   useEffect(() => {
// //     // Si ya cargamos el script antes, no lo volvemos a insertar
// //     if (document.getElementById(TAWK_SCRIPT_ID)) return

// //     const script = document.createElement('script')
// //     script.async = true
// //     script.src = 'https://embed.tawk.to/692f6f8b7d43ed1981ed0f62/1jbgknegb'
// //     script.charset = 'UTF-8'
// //     script.setAttribute('crossorigin', '*')
// //     script.id = TAWK_SCRIPT_ID

// //     document.body.appendChild(script)
// //   }, [])
// // }









// // import { useEffect } from 'react'

// // const TAWK_SCRIPT_ID = 'tawk-to-script'

// // export function useTawkChat(enabled) {
// //   useEffect(() => {
// //     if (!enabled) return

// //     // Evitar duplicar script si ya existe
// //     if (document.getElementById(TAWK_SCRIPT_ID)) return

// //     // Pega aquí el snippet que te dio Tawk.to, adaptado a JS
// //     const s1 = document.createElement('script')
// //     const s0 = document.getElementsByTagName('script')[0]

// //     s1.async = true
// //     s1.src = 'https://embed.tawk.to/692f6f8b7d43ed1981ed0f62/1jbgknegb' // tu URL de Tawk
// //     s1.charset = 'UTF-8'
// //     s1.setAttribute('crossorigin', '*')
// //     s1.id = TAWK_SCRIPT_ID

// //     s0.parentNode.insertBefore(s1, s0)

// //     // Cleanup al desmontar o cuando enabled pase a false
// //     return () => {
// //       const existing = document.getElementById(TAWK_SCRIPT_ID)
// //       if (existing) existing.remove()

// //       // Opcional: limpiar el widget ya renderizado
// //       if (window.Tawk_API && window.Tawk_API.hideWidget) {
// //         try {
// //           window.Tawk_API.hideWidget()
// //         } catch {}
// //       }
// //       delete window.Tawk_API
// //       delete window.Tawk_LoadStart

// //       // El iframe de Tawk suele estar en un div propio
// //       const tawkDiv = document.querySelector("[id^='tawk_']")
// //       if (tawkDiv) tawkDiv.remove()
// //     }
// //   }, [enabled])
// // }

// {/* <!--Start of Tawk.to Script--> */}
// {/* <script type="text/javascript">
// var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
// (function(){
// var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
// s1.async=true;
// s1.src='https://embed.tawk.to/692f6f8b7d43ed1981ed0f62/1jbgknegb';
// s1.charset='UTF-8';
// s1.setAttribute('crossorigin','*');
// s0.parentNode.insertBefore(s1,s0);
// })();
// </script> */}
// {/* <!--End of Tawk.to Script--> */}